import { classify } from 'sidecar-utilities'

export const menuStyle = classify({
  specLayout: 'rounded-lg',
  specColor: 'color-bgDefaultContainer',
  specElevation: 'elevation-2nd-floor z-20',
  specWidth: 'min-w-30 max-w-2xs',
  specHeight:
    'max-h-[var(--radix-dropdown-menu-content-available-height)] overflow-y-auto',
  // animate depending on which direction the menu will grow from
  animateDown: 'data-open:data-[side=bottom]:animate-slide-down',
  animateUp: 'data-open:data-[side=top]:animate-slide-up',
  animationOrigin:
    'origin-[var(--radix-dropdown-menu-content-transform-origin)]',
})

export const sectionTitleStyle = classify({
  specLayout: 'py-3 px-4 border-t first-of-type:border-none',
  specColor: 'color-layer-weak-default color-border-weak-default',
  specType: 'sh-body-sm sh-all-caps color-textOnDefaultStrong',
})

// ul
export const listStyle = title =>
  classify({
    removeDefaults: 'p-0',
    specLayout: !title && 'border-t first-of-type:border-none',
    specColor: 'color-border-weak-default',
    group: 'group/list',
  })

// li
export const itemStyles = 'group/item'

// menu items
const sharedButtonLinkStyles = ({ disabled, selected }) =>
  classify({
    specColor: 'color-bgDefaultContainer',
    specEffects:
      !disabled && !selected
        ? 'hover:color-bgDefaultContainer-hover active:color-bgDefaultContainer-active focus:color-bgDefaultContainer-hover group-data-[highlighted]/item:color-bgDefaultContainer-hover'
        : null,
    animation: 'transition-all duration-200',
    specLayout: 'py-3 px-4 gap-3',
    layout: 'flex flex-row justify-start items-center w-full',
    group: 'group/link',
    // add rounded corners to the first and last links so
    // their bg color doesn't bleed into the menu's border radius
    corners:
      'group-first/list:group-first/item:rounded-t-lg group-last/list:group-last/item:rounded-b-lg',
    disabledCursor: disabled ? 'cursor-not-allowed' : null,
    selectedCursor: selected ? '!cursor-default' : null,
    defaultCursor: !disabled && !selected ? 'cursor-pointer' : null,
    underline: '!no-underline',
  })

export const linkStyles = ({ disabled, selected }) =>
  sharedButtonLinkStyles({ disabled, selected })

export const buttonStyles = ({ disabled, selected }) =>
  classify({
    sharedStyles: sharedButtonLinkStyles({ disabled, selected }),
    // needed to reset default button text-center
    typography: 'text-left',
    textColor:
      !disabled && !selected
        ? 'color-textPrimary hover:color-textPrimary-hover focus:color-textPrimary-hover active:color-textPrimary-active'
        : null,
  })

export const iconStyles = ({ disabled, selected }) =>
  classify({
    specColor: !disabled ? 'color-icon-default' : 'color-iconPrimary-disabled',
    specEffects:
      !disabled && !selected
        ? 'group-hover/link:color-iconPrimary-hover group-active/link:color-iconPrimary-active'
        : null,
  })

export const titleStyles = ({ disabled, selected }) =>
  classify({
    bold: selected ? 'sh-strong' : null,
    specColor: disabled ? 'color-textPrimary-disabled' : null,
    specEffects:
      !disabled && !selected
        ? 'group-hover/link:color-textPrimary-hover group-active/link:color-textPrimary-active group-focus/link:color-textPrimary-hover'
        : null,
  })

export const subtitleStyles = disabled =>
  classify({
    specLayout: 'sh-body-sm',
    specColor: !disabled
      ? 'color-textOnDefaultWeak'
      : 'color-textPrimary-disabled',
  })
